export default __webpack_public_path__ + "static/media/format_study4.40006c29.svg";